import styled from "styled-components";

export const Container = styled.div`
  width: 384px;
  background: white;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  height: calc(100% - 100px);
`;

export const AccountSection = styled.div`
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
`;

export const InvoicesSection = styled.div`
  padding: 24px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const InvoiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const EmptyInvoiceList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-top: 50px;
`;
